/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  wrapRoot: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  detailValueText: {
    marginLeft: theme.spacing(.5),
  },
  pointer: {
    size: "medium",
    cursor: "pointer",
    marginTop: theme.spacing(.5),
    marginLeft: theme.spacing(1),
  },
  emptyScreenRootSubEnterprise: {
    flexGrow: 1,
    position: "relative",
    marginTop: theme.spacing(0.375),
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: theme.spacing(0.75),
    borderTopRightRadius: theme.spacing(0.75),
  },
  componentHeading: {
    padding: theme.spacing(2),
    fontWeight: 700,
    borderWidth: "0px 0px thin",
    borderStyle: "solid",
    borderColor: "#b8b8b840",
  },
  hide: {
    display: "none",
  },
  loader: {
    textAlign: "center",
    alignItems: "center",
    padding: theme.spacing(1.5),
  },
  topLeftHeaderContainer: {
    display: "flex",
    color: theme.palette.text.secondary,
    backgroundColor: "#F6F7FA",
    borderRight: "1px solid #E0E0E0",
    width: "320px",
  },
  topRightHeaderContainer: {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  rightContainer: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
  },
  containerGid: {
    position: "relative",
  },
  noClients: {
    marginTop: theme.spacing(1.75),
    padding: theme.spacing(1),
  },
  listItemPaper: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    overflowY: "auto",
    // borderRight: ".5px solid #E0E0E0",
  },
  displayNameHeading: {
    marginLeft: theme.spacing(2),
  },
  deleteIcon: {
    marginLeft: "auto",
  },
  containerAlignItems: {
    alignItems: "center",
  },
  searchListContainer: {
    height: "100%",
  },
  listContainerBorder: {
    border: "1px solid #e0e0e0",
  },
  detailContainer: {
    overflowY: "auto",
    padding: 0,
  },
  tabpanel: {
    padding: 0,
  },
  tabsWrap: {
    // top: '12.5%',
    // left: '40%',
    // position: "absolute",
  },
  tabs: {
    borderTopColor: theme.palette.divider,
    borderBottomColor: theme.palette.divider,
    borderTopStyle: "solid",
    borderTopWidth: "thin",
    borderBottomStyle: "solid",
    borderBottomWidth: "thin",
  },
  tab: {
    fontSize: "16px",
    color: theme.palette.text.primary,
  },
  threeDotMenu: {
    display: "flex",
    flexDirection: "column",
    width: theme.spacing(3),
  },
  menuItemText: {
    marginLeft: theme.spacing(1.5),
  },
  ListItemContent: {
    display: "flex",
    justifyContent: "space-between",
  },
  threeDotBox: {
    display: "flex",
    alignItems: "center",
  },
  menuIconStyle: {
    minWidth: theme.spacing(5),
  },
  textEllipsisPrimary: {
    whiteSpace: 'nowrap',
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "80%",
  },
  textEllipsisSecondary: {
    whiteSpace: 'nowrap',
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "80%",
  },
  detailsBox: {
    display: "flex",
    alignItems: "center",
  },
  detailsBoxItems: {
    alignItems: "center",
    paddingLeft: theme.spacing(3),
    display: "flex",
  },
  appBar: {
    width: "194px",
  },
  emptyScreenRoot: {
    flexGrow: 1,
    marginTop: theme.spacing(0.375),
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: theme.spacing(0.75),
    borderTopRightRadius: theme.spacing(0.75),
  },
}));
